import React, {useEffect, useMemo, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {startLoadding, stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  CreateInvoiceForClient,
  GetPurchaseHistory,
} from '../../../GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'
import {useGetCreditUsagePerMonthQuery} from '../../../../../../services/cellcast.v2'
import moment from 'moment-timezone'
import {ACCOUNT_TYPE, STRIPE_PAYMENT_STATUS} from '../../../../../Utils/Constant/ConstantForWebsite'
import DatePicker from 'react-datepicker'

const CreateInvoice = ({show, handleClose, pay}: any) => {
  const UserProfileData = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const currentDate = new Date()

  const dispatch = useDispatch()
  const param: any = useLocation()
  const [quickSms, setQuickSms] = useState('sms')
  const [qty, setQty] = useState(0)
  const [price, setPrice] = useState(0)
  const [error, setError] = useState('')

  const [billingDate, setBillingDate] = useState(moment().subtract(1, 'month'))

  const priceRateData = useSelector((state: any) => state?.priceRules?.RateCardList)
  const PriceRate = Array.isArray(priceRateData) ? priceRateData : []

  const {data, isFetching} = useGetCreditUsagePerMonthQuery({
    month: billingDate.month() + 1,
    year: billingDate.year(),
    userId: UserProfileData?._id,
  })

  const isPostPaid = UserProfileData?.accountType === ACCOUNT_TYPE.POSTPAID

  useEffect(() => {
    let sms = PriceRate?.filter((key: any) => key?.type == 'SMS')
    let mms = PriceRate?.filter((key: any) => key?.type == 'MMS')

    if (quickSms == 'sms') {
      let price =
        sms?.find((key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty) ==
        undefined
          ? sms?.find(
              (key: any) =>
                key?.creditendrange === Math.max(...sms.map((o: any) => o?.creditendrange))
            )?.finalPrice
          : sms?.find((key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty)
              ?.finalPrice
      if (price) {
        setPrice(price)
      }

      if (isPostPaid && UserProfileData?.postPaidLimitConfig?.smsFlatRatePrice > 0) {
        setPrice(UserProfileData?.postPaidLimitConfig?.smsFlatRatePrice)
      }
    } else {
      let price =
        mms?.find((key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty) ==
        undefined
          ? mms?.find(
              (key: any) =>
                key?.creditendrange === Math.max(...mms.map((o: any) => o?.creditendrange))
            )?.finalPrice
          : mms?.find((key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty)
              ?.finalPrice
      if (price) {
        setPrice(price)
      }

      if (isPostPaid && UserProfileData?.postPaidLimitConfig?.mmsFlatRatePrice > 0) {
        setPrice(UserProfileData?.postPaidLimitConfig?.mmsFlatRatePrice)
      }
    }
  }, [quickSms, qty, UserProfileData?.postPaidLimitConfig])

  const handleInput = (e: any) => {
    setQty(e?.target?.value)

    if (isPostPaid) {
      return
    }

    if (e?.target?.value > 200000 || e?.target?.value < 0) {
      setError('Max limit is 200000')
    } else {
      setError('')
    }
  }

  const ClosePopup = () => {
    handleClose()
    setQty(0)
    setPrice(0)
  }

  const handleCheckout = () => {
    dispatch(startLoadding())
    dispatch(
      CreateInvoiceForClient({
        credit: {
          type: quickSms,
          priceperItems: price,
          credits: qty,
        },
        month: isPostPaid ? billingDate.month() + 1 : null,
        year: isPostPaid ? billingDate.year() : null,
        userId: UserProfileData?._id,
        status: isPostPaid ? STRIPE_PAYMENT_STATUS.DRAFT : STRIPE_PAYMENT_STATUS.OPEN,
      })
    ).then((res: any) => {
      handleClose()
      dispatch(stopLoading())
      AuthenticateUser('see-credit-history') &&
        dispatch(GetPurchaseHistory({id: UserProfileData?._id}))
      dispatch(fetchAsyncUserDetails())
      toast.success(res?.payload?.message)
    })
    // .catch((err: any) => {
    //   dispatch(stopLoading())
    //   handleClose()
    //   toast.error('Payment fail')
    // })
  }

  useEffect(() => {
    const smsCreditUsed = data?.data.find((it) => it?._id === 'sms')?.totalUsedCredit || 0
    const mmsCreditUsed = data?.data.find((it) => it?._id === 'mms')?.totalUsedCredit || 0

    if (isPostPaid) {
      if (quickSms === 'sms') {
        setQty(smsCreditUsed as number)
      } else {
        setQty(mmsCreditUsed as number)
      }
    }
  }, [data, quickSms])

  useEffect(() => {
    if (isFetching) {
      dispatch(startLoadding())
    } else {
      dispatch(stopLoading())
    }
  }, [isFetching, dispatch])

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header border-bottom'>
          <h2>Create Invoice</h2>
          <div className='btn btn-icon btn-sm' onClick={ClosePopup}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-20 pb-15'>
          {isPostPaid && (
            <div className='row mb-2'>
              <div className='col-7  border-end pe-15'>
                <DatePicker
                  dateFormat='MM/yyyy'
                  showMonthYearPicker
                  inline
                  className=' border-0 form-control form-control-lg form-control-solid'
                  placeholderText='Pick data & time'
                  onChange={(update: any) => {
                    setBillingDate(moment(update))
                  }}
                  selected={new Date(billingDate.toDate())}
                  disabled={isFetching}
                />
              </div>
              <div className='col-4 align-items-center'>
                <div className='d-flex justify-content-center gap-4'>
                  <h5>from {billingDate.startOf('month').format('L')}</h5>
                  <h5>to {billingDate.endOf('month').format('L')}</h5>
                </div>
              </div>
            </div>
          )}
          <div className='row mb-2'>
            <div className='col-7 border-end pe-15'>
              <div className='d-flex gap-4'>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='sms'
                    checked={quickSms == 'sms'}
                    id='quick_sms_radio2'
                    onChange={() => {
                      setQuickSms('sms')
                    }}
                  />
                  <label className='btn btn-light-info py-2 px-5' htmlFor='quick_sms_radio2'>
                    <span className='fw-500 fs-2'>SMS</span>
                  </label>
                </div>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='mms'
                    checked={quickSms == 'mms'}
                    id='quick_mms_radio2'
                    onChange={() => {
                      setQuickSms('mms')
                    }}
                  />
                  <label
                    className='btn btn-active-info btn-light-info py-2 px-5'
                    htmlFor='quick_mms_radio2'
                  >
                    <span className='fw-500 fs-2'>MMS</span>
                  </label>
                </div>
              </div>
              <div className='mt-7'>
                <label className=' col-form-label fw-normal fs-6'>
                  {isPostPaid ? 'Credits send' : 'How many credits should be added?'}
                </label>
                <input
                  maxLength={7}
                  name='number'
                  onChange={handleInput}
                  type='text'
                  value={qty}
                  className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                />

                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'>{error}</div>
                </div>
              </div>
            </div>
            <div className='col-5 ps-10'>
              <h4 className='mb-4'>Total Cost (inc. GST)</h4>
              <h1 className='text-info fs-3qx fw-boldest'>
                ${(+qty * price + (+qty * price * 10) / 100).toFixed(2)}
              </h1>
              <div className='fs-6 text-gray-500'>Total: {(+qty * price).toFixed(2)}</div>
              <div className='fs-6 text-gray-500'>
                GST: {((+qty * price * 10) / 100).toFixed(2)}
              </div>
              <div className='fs-6 text-gray-500'>or {price}/message</div>
            </div>
            <div className='d-flex flex-center mt-20'>
              <div id='kt_drawer_chat_close'>
                <button
                  type='button'
                  onClick={() => {
                    handleClose()
                    setPrice(0)
                    setQty(0)
                  }}
                  className='btn btn-light text-hover-white rounded btn-active-primary me-3 w-100px p-3 fw-500 me-2'
                >
                  Discard
                </button>
              </div>
              <button
                type='submit'
                className='btn btn-light btn-primary fw-500 rounded  w-100px p-3 border border-primary'
                disabled={qty * price == 0 || error !== ''}
                onClick={handleCheckout}
              >
                <span className='indicator-label'>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateInvoice
